<div
  class="flex items-center justify-center min-h-screen bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-gray-900 dark:to-gray-800"
>
  <div
    class="w-full max-w-2xl p-4 bg-white shadow-2xl dark:bg-gray-900 sm:p-10 sm:rounded-3xl"
  >
    <div class="text-center">
      <div
        class="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-red-100 rounded-full dark:bg-green-700"
      >
        <svg
          class="h-12 w-12 text-red-600 dark:text-green-100"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </div>
      <h1 class="text-4xl font-extrabold text-red-700 dark:text-red-400">
        Payment Cancel!
      </h1>

      <p class="mt-6 text-xl text-blue-600 dark:text-blue-400">Try Again</p>
      <p class="mt-4 text-sm text-gray-700 dark:text-gray-400">
        If you have any questions or need further assistance, feel free to
        contact us at:
        <a
          href="mailto:admin@eliteai.tools"
          class="font-medium text-indigo-600 dark:text-indigo-400 underline"
        >
          contact&#64;vinmarts.in
        </a>
      </p>
    </div>
    <div class="mt-8 text-center">
      <a
        routerLink="/"
        class="inline-block px-6 py-2 text-lg font-medium text-white transition-transform rounded-full shadow-lg bg-gradient-to-r from-indigo-600 to-blue-600 hover:scale-105 hover:from-indigo-700 hover:to-blue-700 dark:from-indigo-500 dark:to-blue-500 dark:hover:from-indigo-600 dark:hover:to-blue-600"
      >
        Back to Home
      </a>
    </div>
  </div>
</div>
